import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21244765"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "d-flex d-full-w" }
const _hoisted_3 = { class: "d-flex-1f" }
const _hoisted_4 = { class: "search-wrapper" }
const _hoisted_5 = { class: "banner" }
const _hoisted_6 = {
  key: 0,
  class: "banner-tip"
}
const _hoisted_7 = { class: "tip" }
const _hoisted_8 = { class: "middle-nav" }
const _hoisted_9 = { class: "nav-wrapper" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "middle-nav-labal" }
const _hoisted_13 = { class: "d-page-margin goods service d-flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f name" }, "送货上门", -1))
const _hoisted_15 = { class: "list-wrapper" }
const _hoisted_16 = { class: "list" }
const _hoisted_17 = {
  key: 0,
  class: "d-page-margin goods service d-flex"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f name" }, "上门服务", -1))
const _hoisted_19 = { class: "list-wrapper" }
const _hoisted_20 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_HomePartActivitiesView = _resolveComponent("HomePartActivitiesView")!
  const _component_ShopCard = _resolveComponent("ShopCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_search, {
          shape: "round",
          background: "#f6f6f6",
          class: "search",
          readonly: "",
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push(`/shop/page/search`))),
          modelValue: _ctx.searchVal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchVal) = $event)),
          placeholder: "搜索"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "search_btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goSearch && _ctx.goSearch(...args)))
        }, "搜索")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_RatioHeightContainer, { ratio: 41.69 }, {
        default: _withCtx(() => [
          _createVNode(_component_van_swipe, {
            class: "banner-wrapper",
            autoplay: 3000,
            "show-indicators": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouseImgs, (item) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, {
                  class: "banner-item",
                  key: item
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_image, {
                      class: "banner-item-img-wrapper",
                      width: "100%",
                      height: "100%",
                      alt: "图片加载中...",
                      radius: 4,
                      fit: "cover",
                      src: _ctx.img(item.imgKey),
                      onClick: ($event: any) => (_ctx.goImgurl(item.url))
                    }, null, 8, ["src", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.viewShopHomeTipsHide == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_van_row, { justify: "space-between" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, { span: "16" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_van_icon, { name: "passed" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.freeShippingTips) + "     ", 1),
                      _createVNode(_component_van_icon, { name: "passed" }),
                      _createTextVNode(" 上门服务更实惠 ")
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.showGYLink)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "8"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "pool",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push(`/gy/home`)))
                        }, [
                          _createVNode(_component_van_icon, { name: " iconfont d-shop-gongyichi" }),
                          _createTextVNode(" 公益池 "),
                          _createVNode(_component_van_icon, { name: "arrow" })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_swipe, { "show-indicators": true }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, { key: item }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_grid, {
                    border: false,
                    "column-num": 5
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (obj) => {
                        return (_openBlock(), _createBlock(_component_van_grid_item, {
                          onClick: ($event: any) => (_ctx.middleNavClick(obj)),
                          class: "middle-nav-item",
                          key: obj.id
                        }, {
                          default: _withCtx(() => [
                            (
                                    obj.id == 1 ||
                                    obj.id == 2 ||
                                    obj.id == 3 ||
                                    obj.id == 4
                                )
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: obj.img,
                                  class: "icon"
                                }, null, 8, _hoisted_10))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.img(obj.img),
                                  class: "icon"
                                }, null, 8, _hoisted_11)),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(obj.classifyName), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_HomePartActivitiesView),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", {
        class: "more",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goList(1)))
      }, [
        _createTextVNode(" 更多 "),
        _createVNode(_component_van_icon, { name: "arrow" })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item
          }, [
            _createVNode(_component_ShopCard, {
              data: item,
              home: 1
            }, null, 8, ["data"])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.serviceList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", {
            class: "more",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goList(2)))
          }, [
            _createTextVNode(" 更多 "),
            _createVNode(_component_van_icon, { name: "arrow" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item
          }, [
            _createVNode(_component_ShopCard, {
              data: item,
              home: 1
            }, null, 8, ["data"])
          ]))
        }), 128))
      ])
    ])
  ]))
}